const ExperienceData = [
  {
    id: 1,
    position: "Full Stack Web Developer Student",
    company: "Le Wagon, Singapore",
    desc: "Attended a 9-week intensive coding bootcamp learning Ruby, HTML, CSS, Bootstrap, JavaScript, SQL, git, GitHub, Figma prototyping, DB Schema planning, OOP, MVC (Model View Controller), Object Relational Mapping, Heroku and Ruby on Rails. Designed, implemented and shipped to production 2 Ruby on Rails prototypes.",
    duration: "Apr 2022 - June 2022",
    icon: "study"
  },
  {
    id: 2,
    position: "Junior Java Programmer Trainee",
    company: "UBS AG, Singapore",
    desc: "Debugged Java code and resolved all error messages.",
    duration: "Jul 2021 - Dec 2021 (6 Months)",
    icon: "work"
  },
  {
    id: 3,
    position: "Technology Business Analyst Trainee",
    company: "UBS AG, Singapore",
    desc: "Translated business requirements from SMEs and product owner into solution features. Collaborated with UI/UX specialist to create wireframes as per business requirements. Wrote detailed epics, user stories and acceptance criteria, working with the Product Owner to prioritize stories in the product backlog in JIRA for selection for the sprint backlog.",
    duration: "Nov 2020 - Jul 2021 (9 Months)",
    icon: "work"
  },
  {
    id: 4,
    position: "Undergraduate Research Engineer",
    company: "National University of Singapore",
    desc: "B.Eng Honors Year Research:  Influence of pH on the corrosion of AZ series Magnesium Alloys. Conducted experiments using analytical methods such as the Tafel extrapolation, Electrochemical Impedance Spectroscopy (EIS), Scanning Electron Microscopy (SEM) and the pH meter. Analyzed corrosion data like Tafel plots, Nyquist plots, SEM images, Hydrogen Evolution rates and Weight Loss data, to understand the corrosion mechanism of AZ91.",
    duration: "Aug 2019 - May 2020 (10 Months)",
    icon: "study"
  },
  {
    id: 5,
    position: "Content Marketing Intern",
    company: "Seeed Studio, Shenzhen, China",
    desc: "Brainstormed technical content and researched keywords for SEO articles, thereby writing the company's top 3 most visited online articles and increasing web traffic. Wrote online quick-start guides on how to set up basic electronic projects with Arduino, simplifying technical jargon into information more easily understood by the layman. Drove awareness of Seeed's services through Facebook and Twitter and assisted with the designing of Email Digital Marketing campaigns, increasing the amount of customer engagement.",
    duration: "Jan 2019 - Jul 2019 (7 Months)",
    icon: "work"
  },
]

export default ExperienceData;
